module.exports = __webpack_public_path__ + "img/ac11_thumb.7a3e4d30.jpg";